// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLaserSpacingBtwPoint_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.5 2.5C4.5 3.60457 3.60457 4.5 2.5 4.5 1.39543 4.5.5 3.60457.5 2.5.5 1.39543 1.39543.5 2.5.5 3.60457.5 4.5 1.39543 4.5 2.5ZM4.5 9.5C4.5 10.6046 3.60457 11.5 2.5 11.5 1.39543 11.5.5 10.6046.5 9.5.5 8.39543 1.39543 7.5 2.5 7.5 3.60457 7.5 4.5 8.39543 4.5 9.5ZM11.5 3.5 9 .5 6.5 3.5H8.5V8.5H6.5L9 11.5 11.5 8.5H9.5V3.5H11.5Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 2C6 3.10457 5.10457 4 4 4 2.89543 4 2 3.10457 2 2 2 .895431 2.89543 0 4 0 5.10457 0 6 .895431 6 2ZM6 14C6 15.1046 5.10457 16 4 16 2.89543 16 2 15.1046 2 14 2 12.8954 2.89543 12 4 12 5.10457 12 6 12.8954 6 14ZM8 4 10 4V12H8L11 16 14 12H12V4L14 4 11 0 8 4Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLaserSpacingBtwPoint is a generated icon component.
 */
let IconMedLaserSpacingBtwPoint = IconMedLaserSpacingBtwPoint_1 = class IconMedLaserSpacingBtwPoint extends IconBaseElement {
    render() {
        return html `${IconMedLaserSpacingBtwPoint_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLaserSpacingBtwPoint.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedLaserSpacingBtwPoint = IconMedLaserSpacingBtwPoint_1 = __decorate([
    customElement('zui-icon-med-laser-spacing-btw-point')
], IconMedLaserSpacingBtwPoint);
export { IconMedLaserSpacingBtwPoint };
